import React from 'react';
import { Radio } from '@material-ui/core';
import { BpCheckedIcon, BpIcon } from './RadioMLStyled';

function RadioML(props) {
  return (
    <Radio
      sx={{
        '&:hover': {
          bgcolor: 'transparent',
        },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export default RadioML;
